module.exports = __webpack_public_path__ + "resources/img/bg_cover_customer_v2.52b10fba3df3be90c1941df8576a833a.png";